<script lang="ts" setup>
import SimpleListItem from './SimpleListItem/SimpleListItem.vue';
import type { Feature } from '@dh-io-owpi/backend-api/src/data-contracts';

defineProps<{
  items: Feature[];
  modelName?: string;
}>();

const emit = defineEmits<{ 'item-click': [item: Feature, index: number] }>();
</script>

<template>
  <div class="owpi-simple-list">
    <SimpleListItem
      v-for="(item, i) in items"
      :key="item.equipmentId"
      v-bind="item"
      :modelName
      @click="emit('item-click', item, i)"
    />
  </div>
</template>

<style lang="scss">
.owpi-simple-list {
  display: grid;
  grid-gap: var(--wb-grid-gutter-width);
  align-items: flex-start;

  @include wb.breakpoint-from(mq5) {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
